import { API_URL } from "config";
import Http from "util/https";
import { CsvUploadOrderAskResponseApi } from "../types/index";

/**
 * 注文週次補充CSVアップロードApi
 * @param args 週次補充CSVアップロードApiのパラメータ
 * @returns CSVCountCheckStock[]
 */
export default async function uploadWeeklyCsv(args: { csv_file: File }) {
  const params1 = {
    operation: 4, // presigned URL発行
    lastModified: args.csv_file.lastModified,
  };
  const http1 = Http.default.alterAuth({useToken: true});
  const url1 = `${API_URL}/order/weekly/csv/operation`;
  const res1 = await http1.get<{ presignedUrl: string, s3Key: string, process_id: string }>(url1, { params: params1 });
  // presigned URLを使ってファイルを直接S3にアップロード
  const { presignedUrl, s3Key, process_id } = res1.data;
  const http2 = Http.default; // 認証不要
  await http2.put(presignedUrl, args.csv_file, {
    headers: {
      "Content-Type": args.csv_file.type || "text/csv",
    },
  });

  // アップロード完了後、APIに完了通知を送って後処理を開始させる
  // ファイル送信
  const http3 = Http.default.alterAuth({useToken: true});
  const params3 = {
    process_id, // 任意の識別子を送る（例: プロセスID）
    s3Key, // S3にアップロードしたファイルのキー
  };
  const url3 = `${API_URL}/order/weekly/csv/operation`;
  await http3.post<CsvUploadOrderAskResponseApi>(url3, params3);

}
